<template>
  <div class="animated fadeIn">

    <b-row class="bg-gray-100">
        <b-col md="12" class="text-center mb-3">
          <br>
          <h1 class="display-3 font-weight-bold">Model Results</h1>
          <p>
            

          <h3 class="font-weight-normal"> Our predictive model resulted in a mean absolute percentage error (MAPE) of: </h3>
          <p>
          <h1 class= "display-3 font-weight-bold">12%</h1>
          <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png">
          <br>
        
          <h3 class="font-weight-normal"> This equates to an approximate accuracy of: </h3>
          <p>
          <h1 class= "display-3 font-weight-bold">88%</h1>
          <img src="https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png">
          <br>
        </b-col>
      </b-row>
          
<br>
<br>
<b-row class="background-color-gray">
  <b-col md="12" class="text-center mb-3">
      <h3 class="font-weight-normal"> We predict that during the week of 12/23/17 - 12/31/17 there will be:</h3>
  </b-col>
</b-row>

    <div class="row justify-content-center mt-3">
      <div class="col-sm-6 col-md-4">
        <div class="card">
          <div class="card-block text-center">
            <div class="text-muted small text-uppercase font-weight-bold">Number of Visitors</div>
            <div class="h2 py-1 text-blue">243</div>
            <div class="chart-wrapper">
                <bar-example/>
            </div>
          </div>
        </div>
      </div><!--/col-->
      <div class="col-sm-6 col-md-4">
        <div class="card">
          <div class="card-block text-center">
            <div class="text-muted small text-uppercase font-weight-bold">Number of Sessions</div>
            <div class="h2 py-1">1743</div>
            <div class="chart-wrapper">
                <bar-sessions/>
              </div>
          </div>
        </div>
    </div>
  </div>
  
 
    
        <b-row class="justify-content-center">
           <b-col md="8">
            <b-card>  
            <line-example/>
            </b-card>
           </b-col>
        </b-row>

        <b-row class="bg-gray-100" id="InstructionsForAstaea">
            <b-col md="12" class="text-center mb-3">
              <br>
              <h1 class="display-3 font-weight-bold">Instructions for Astraea</h1>
              <p>
              <h3 class="font-weight-normal"> To retrieve files & instructions for validating our model please log in below: </h3>
              <p>
              <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png">
              <h3 class= "display-5 font-weight-bold">log in widget will go here & redirect to new page</h3>
              <p>
              <img src="https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png">
              <br>
              </p>
           </b-col>
        </b-row>



<!-- <div class="row">
  <b-card
    header-tag="header"
    footer-tag="footer"
    class= "col-12">
    <div slot="header">
      <i class="fa fa-align-justify"></i> <strong>Bootstrap Jumbotron</strong>
      <div class="card-actions">
        <a href="https://bootstrap-vue.js.org/docs/components/jumbotron" target="_blank">
          <small class="text-muted">docs</small>
        </a>
      </div>
    </div>
    <div>
      <b-jumbotron header="Meet the Team" lead="Team H.A.C.K.D.">
        <p>For more information visit website</p>
        <b-btn variant="primary" href="#">More Info</b-btn>
      </b-jumbotron>
    </div>
  </b-card>
</div> -->

  <!-- <b-row class="justify-content-center">
    <b-col sm="6" lg="2" class="offset">
      <b-card no-body class="bg-primary">
        <b-card-body class="pb-0">
          <b-dropdown class="float-right" variant="transparent p-0" right>
            <template slot="button-content">
              <i class="icon-settings"></i>
            </template>
            <b-dropdown-item>Action</b-dropdown-item>
            <b-dropdown-item>Another action</b-dropdown-item>
            <b-dropdown-item>Something else here...</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          <h4 class="mb-0">9.823</h4>
          <p>Members online</p>
        </b-card-body>
        <card-line1-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
      </b-card>
    </b-col>
    <b-col sm="6" lg="2">
      <b-card no-body class="bg-info">
        <b-card-body class="pb-0">
          <b-dropdown class="float-right" variant="transparent p-0" right no-caret>
            <template slot="button-content">
              <i class="icon-location-pin"></i>
            </template>
            <b-dropdown-item>Action</b-dropdown-item>
            <b-dropdown-item>Another action</b-dropdown-item>
            <b-dropdown-item>Something else here...</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          <h4 class="mb-0">9.823</h4>
          <p>Members online</p>
        </b-card-body>
        <card-line2-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
      </b-card>
    </b-col>
    <b-col sm="6" lg="2">
      <b-card no-body class="bg-warning">
        <b-card-body class="pb-0">
          <b-dropdown class="float-right" variant="transparent p-0" right>
            <template slot="button-content">
              <i class="icon-settings"></i>
            </template>
            <b-dropdown-item>Action</b-dropdown-item>
            <b-dropdown-item>Another action</b-dropdown-item>
            <b-dropdown-item>Something else here...</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          <h4 class="mb-0">9.823</h4>
          <p>Members online</p>
        </b-card-body>
        <card-line3-chart-example class="chart-wrapper" style="height:70px;" height="70"/>
      </b-card>
    </b-col>
    <b-col sm="6" lg="2">
      <b-card no-body class="bg-danger">
        <b-card-body class="pb-0">
          <b-dropdown class="float-right" variant="transparent p-0" right>
            <template slot="button-content">
              <i class="icon-settings"></i>
            </template>
            <b-dropdown-item>Action</b-dropdown-item>
            <b-dropdown-item>Another action</b-dropdown-item>
            <b-dropdown-item>Something else here...</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          <h4 class="mb-0">9.823</h4>
          <p>Members online</p>
        </b-card-body>
        <card-bar-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
      </b-card>
    </b-col>
    <b-col sm="6" lg="2">
      <b-card no-body class="bg-danger">
        <b-card-body class="pb-0">
          <b-dropdown class="float-right" variant="transparent p-0" right>
            <template slot="button-content">
              <i class="icon-settings"></i>
            </template>
            <b-dropdown-item>Action</b-dropdown-item>
            <b-dropdown-item>Another action</b-dropdown-item>
            <b-dropdown-item>Something else here...</b-dropdown-item>
            <b-dropdown-item disabled>Disabled action</b-dropdown-item>
          </b-dropdown>
          <h4 class="mb-0">9.823</h4>
          <p>Members online</p>
        </b-card-body>
        <card-bar-chart-example class="chart-wrapper px-3" style="height:70px;" height="70"/>
      </b-card>
    </b-col>
  </b-row>

<div class="container">
<b-row class="justify-content-center">
    <b-col sm="6" lg="2">
      <img src="https://www.elderresearch.com/hubfs/Halee-Mason.jpg?t=1521743449692" class="image--cover">
    </b-col>
    <b-col sm="6" lg="2">
      <img src="https://www.elderresearch.com/hubfs/Anna-Godwin.jpg?t=1521743449692" alt="" class="image--cover" />
    </b-col>
    <b-col sm="6" lg="2">
      <img src="https://www.elderresearch.com/hubfs/Cory-Everington.jpg?t=1521743449692" alt="" class="image--cover" />
    </b-col>
    <b-col sm="6" lg="2">
      <img src="https://i1.rgstatic.net/ii/profile.image/321203980439552-1453592404456_Q512/Kazlin_Mason.jpg" alt="" class="image--cover" />
    </b-col>
    <b-col sm="6" lg="2">
      <img src="https://www.elderresearch.com/hubfs/Danny-Brady.jpg?t=1521743449692" alt="" class="image--cover" />
    </b-col>
  </b-row>  
</div> -->
  </div>
</template>

<script>
import BarExample from './charts/BarExample'
import BarSessions from './charts/BarSessions'
import LineExample from './charts/LineExample'

export default {
  name: 'model',
  components: {
    BarExample,
    BarSessions,
    LineExample
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Model.vue